// extracted by mini-css-extract-plugin
export default {"surveyViewLabel":"SurveyView_surveyViewLabel__OohtN","surveyViewItem":"SurveyView_surveyViewItem__KCUP+"};